export const AUTHORITIES = {
  CONTENT_INTERACTIVE: 'content.interactive',
  CONTENT_CARD_EDIT: 'content.card.edit',
  CONTENT_PAGE_EDIT: 'content.page.edit',
  CONTENT_ADMIN: 'content.admin',
};
